<template>
  <section class="pricing-section">
    <div class="container">
      <!-- Pricing Table starts -->
      <b-row class="row">
        <b-col md="4" sm="12" lg="4" xl="4" v-for="data in pricing" :key="data.price" class="py-2">
          <div class="price-card">
            <h2>{{ $t('common.pricing.' + data.name) }}</h2>
            <div style="height: 50px !important;">
              <p>{{ data.description }}</p>
            </div>
            <p class="price"><span>{{ data.price }}</span>/ Month</p>
            <ul class="pricing-offers">
              <li v-for="(feature,idx) in data.features" :key="idx">
                <i class="fa fa-check mr-2 text-primary"
                   :class="feature.value !== 0 ? 'fa-check text-primary' : 'fa-times text-danger'"></i>
                <del v-if="feature.value === 0" class="text-muted">
                  {{ feature.name }}
                </del>
                <span v-else>
                    {{ feature.name }}
                </span>
              </li>
            </ul>
            <b-btn
                v-if="!$auth.user().subscription || (data.name !== $auth.user().subscription.plan)"
                variant="primary"
                :disabled="!!subscribeLoading"
                @click="$emit('choose', data)"
                class="btn-mid">
              <b-spinner class="mx-1 mt-1"  v-if="subscribeLoading === data.name" small></b-spinner>
              {{ $t('pages.pricing.subscribe') }}
            </b-btn>
            <div class="text-end" v-else>
              <h4>
               <span class="badge badge-soft-success py-2">
               {{ $t('pages.pricing.currently') }}
            </span>
              </h4>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
export default {
  name: "PricingTable",
  props: ['pricing', 'subscribeLoading']
}
</script>

<style scoped>
body {
  margin-top: 20px;
}

.section-title {
  position: relative;
}

.section-title h2 {
  color: #1d2025;
  position: relative;
  margin: 0;
  font-size: 24px;
}

@media (min-width: 768px) {
  .section-title h2 {
    font-size: 28px;
  }
}

@media (min-width: 992px) {
  .section-title h2 {
    font-size: 34px;
  }
}

.section-title.title-ex1 h2 {
  padding-bottom: 20px;
}

@media (min-width: 768px) {
  .section-title.title-ex1 h2 {
    padding-bottom: 30px;
  }
}

@media (min-width: 992px) {
  .section-title.title-ex1 h2 {
    padding-bottom: 40px;
  }
}

.section-title.title-ex1 h2:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 12px;
  width: 110px;
  height: 1px;
  background-color: #d6dbe2;
}

@media (min-width: 768px) {
  .section-title.title-ex1 h2:before {
    bottom: 17px;
  }
}

@media (min-width: 992px) {
  .section-title.title-ex1 h2:before {
    bottom: 25px;
  }
}

.section-title.title-ex1 h2:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 12px;
  width: 40px;
  height: 1px;
  background-color: #34c38f;
}

@media (min-width: 768px) {
  .section-title.title-ex1 h2:after {
    bottom: 17px;
  }
}

@media (min-width: 992px) {
  .section-title.title-ex1 h2:after {
    bottom: 25px;
  }
}

.section-title.title-ex1.text-center h2:before {
  left: 50%;
  transform: translateX(-50%);
}

.section-title.title-ex1.text-center h2:after {
  left: 50%;
  transform: translateX(-50%);
}

.section-title.title-ex1.text-right h2:before {
  left: auto;
  right: 0;
}

.section-title.title-ex1.text-right h2:after {
  left: auto;
  right: 0;
}

.section-title.title-ex1 p {
  font-family: "Montserrat", sans-serif;
  color: #8b8e93;
  font-size: 14px;
  font-weight: 300;
}


.price-card {
  background: #ffffff;
  padding: 40px 35px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.price-card:before {
  position: absolute;
  content: "";
  top: 0;
  right: -35px;
  width: 88px;
  height: 88px;
  background: #4c55e5;
  opacity: 0.2;
  border-radius: 8px;
  transform: rotate(45deg);
}

.price-card:after {
  position: absolute;
  content: "";
  top: 30px;
  right: -35px;
  width: 88px;
  height: 88px;
  background: #023bf5;
  opacity: 0.2;
  border-radius: 8px;
  transform: rotate(45deg);
}

.price-card h2 {
  font-size: 26px;
  font-weight: 600;
}

.price-card .btn {
  font-size: 11px;
  border-radius: 100px;
  padding: 0 25px;
  border: 0;
  color: #fff;
  float: right;
}

.price-card .btn.btn-primary {
  border: 0 !important;
}

.price-card:hover {
  background: #fff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  transition-property: box-shadow, border, background;
}

.price-card:hover .btn {
  background: #34c38f;
  border-color: #34c38f;
  transition: all 0.3s;
  transition-property: border-color, background;
}

p.price span {
  display: inline-block;
  padding: 25px 15px 25px;
  padding-right: 0;
  font-size: 50px;
  font-weight: 600;
  position: relative;
}

p.price span:before {
  position: absolute;
  content: "$";
  font-size: 16px;
  top: 40px;
  font-weight: 300;
  left: 5px;
}

.pricing-offers {
  padding: 0 0 10px;
}

.pricing-offers li {
  padding: 0 0 16px;
  line-height: 18px;
}

ul li {
  list-style-type: none;
}

.btn.btn-mid {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
</style>